import { useSelect, useDispatch } from "@wordpress/data";
import { useCallback } from "@wordpress/element";
import { STORE_NAME } from "../store";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

export const AdvancedViewOptions = () => {
	const isSanskritOn = useSelect(
		(select) => select(STORE_NAME).isSanskritOn(),
		[],
	);
	const isWordForWordOn = useSelect(
		(select) => select(STORE_NAME).isWordForWordOn(),
		[],
	);
	const isTranslationOn = useSelect(
		(select) => select(STORE_NAME).isTranslationOn(),
		[],
	);
	const isCommentaryOn = useSelect(
		(select) => select(STORE_NAME).isCommentaryOn(),
		[],
	);
	const { setSanskrit, setWordForWord, setCommentary, setTranslation } =
		useDispatch(STORE_NAME);
	const changeSanskrit = useCallback(
		(checked) => {
			setSanskrit(checked);
		},
		[setSanskrit],
	);

	const changeWordForWord = useCallback(
		(checked) => {
			setWordForWord(checked);
		},
		[setWordForWord],
	);
	const changeTranslation = useCallback(
		(checked) => {
			setTranslation(checked);
		},
		[setTranslation],
	);
	const changeCommentary = useCallback(
		(checked) => {
			setCommentary(checked);
		},
		[setCommentary],
	);

	const options = [
		{ 
			value: 'sanskrit', label: "סנסקריט", checked: isSanskritOn, onChange: changeSanskrit },
		{
			value: 'translation',
			label: "תרגום",
			checked: isTranslationOn,
			onChange: changeTranslation,
		},
		{
			value: 'word-for-word',
			label: "מילה במילה",
			checked: isWordForWordOn,
			onChange: changeWordForWord,
		},
		{
			value: 'commentary',
			label: "התעמקות",
			checked: isCommentaryOn,
			onChange: changeCommentary,
		},
	];

	const handleChange = (event) => {
		const values = event.target.value;

		options.map((option) => {
			if (values.includes(option.value)) {
				option.onChange(true);
			} else {
				option.onChange(false);
			}
		});
	};
	const menuProps = {
		PaperProps: {
			style: {
				width: 300,
			},
		},
	};
	return (
		<FormControl size="small" sx={ { 
			minWidth: { xs: '100%', sm: '150px' } }} >
			<InputLabel id="bbt-view-option-label">אפשרויות תצוגה</InputLabel>
			<Select
				labelId="bbt-view-option-label"
				id="bbt-view-option"
				multiple
				value={options.filter((option) => option.checked).map((option) => option.value)}
				onChange={handleChange}
				input={<OutlinedInput label="אפשרויות תצוגה" />}
				MenuProps={menuProps}
				renderValue={(selected) =>
					options
						.filter((option) => selected.includes(option.value))
						.map((option) => option.label)
						.join(", ")
				}
			>
				{options.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						<Checkbox
							checked={option.checked}
							sx={{
								color: '#327788',
								'&.Mui-checked': {
									color: '#327788',
								},
							}}
						/>
						{option.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}